export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_stratx.png",
      alt: "Nome da extensão",
    },
    title: "Disciplina Quantitativa para investir com consistência",
    text: [
      "A Strat X converte dados de mercado em decisões de investimento automáticas e disciplinadas, eliminando a emoção das suas escolhas. Nossos algoritmos, baseados em modelos matemáticos rigorosamente comprovados, garantem melhor gestão de risco e resultados mais previsíveis. Você investe com inteligência, não com incerteza.",
    ],
    testimonial: {
      text: "Quando o método é sólido, a disciplina deixa de ser um esforço.",
      author: {
        name: "Strat X",
        // "picture": "https://i.pravatar.cc/150?img=70"
      },
    },
  },
  stats: {
    title: "Resultado construído com o tempo.",
    subtitle: "Dados, estatística e automação como pilares de decisão",
    data: [
      {
        value: "+1748",
        description: "Pregões de consistência",
      },
      {
        value: "+1500",
        description: "Operações sem ansiedade.",
      },
      {
        value: "+1240",
        description: "Horas de tempo livre",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Strat X?",
    subtitle: "Veja quais as principais vantagens dos robôs da Strat X.",
    data: [
      {
        title: "Disciplina Operacional Garantida",
        description:
          "Nossas estratégias algorítmicas garantem disciplina operacional e resultados consistentes. Não há espaço para emoção, hesitação ou decisões impulsivas. Cada movimento é calculado, testado e otimizado.",
      },
      {
        title: "Liberdade Financeira",
        description:
          "Ganhe dinheiro enquanto dorme. Nossas estratégias trabalham 24/7 para gerar renda consistente e automatizada. Sem necessidade de ficar preso olhando gráficos, você tem tempo para viver. ",
      },
      {
        title: "Expertise Consolidada",
        description:
          "Nosso time de desenvolvedores especializados cria estratégias que foram testadas e consolidadas no mercado brasileiro e internacional. Cada estratégia passa por rigorosos testes de backtesting e validação em condições reais de mercado antes de ser disponibilizada.",
      },
      {
        title: "Suporte Profissional",
        description:
          "Integrado ao XP, você tem acesso a uma plataforma robusta, confiável e com suporte profissional. ",
      },
      {
        title: "Disciplina Garantida",
        description: "Sem emoção, sem hesitação. Apenas decisões calculadas e otimizadas.",
      },
      {
        title: "Confiança e Segurança",
        description:
          "Estratégias consolidadas e testadas no mercado real. Cada algoritmo passou por validação rigorosa antes de ser disponibilizado.",
      },
    ],
  },
  cta: {
    title: "Crescimento consistente não é sorte, é disciplina.",
    subtitle: "Junte-se aos investidores que confiam na Strat X ",
  },
  about: {
    title: "Sobre o Desenvolvedor",
    subtitle: "A Strat X",
    col1: [
      "Quem Somos",
      "A Strat X é uma empresa especializada no desenvolvimento de estratégias algorítmicas de alto desempenho que transformam a forma como você investe. Criada com uma missão clara: permitir que nossos clientes gerem renda consistente e automatizada, liberando tempo e energia para o que realmente importa na vida. ",
      "Combinamos análise estatística rigorosa, gestão de risco eficiente e automação completa em uma solução integrada ao ecossistema XP, oferecendo uma plataforma robusta e confiável onde você investe com confiança em processos comprovados.",
    ],
    col2: [
      "Nossa Missão ",
      "Democratizar o acesso a estratégias de investimento de alto desempenho, permitindo que nossos clientes ganhem dinheiro enquanto dormem, sem precisar ficar preso olhando gráficos ou desenvolvendo estratégias complexas.",
      "Queremos que você tenha liberdade financeira e qualidade de vida, com investimentos que trabalham para você 24/7.",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Strat X",
  },
  strategies: {
    title: "Onde técnica e resultado se encontram",
    heading: "Robustez quantitativa a serviço da decisão",
    subtitle:
      "Nossas estratégias combinam modelos quantitativos, regras objetivas e gestão ativa de risco para criar um processo operacional consistente. \n\nPara o investidor, isso se traduz em menos decisões manuais, mais clareza sobre o plano e uma experiência de investimento mais estável ao longo do tempo. ",
  },
  testimonials: [
    {
      text: "Estou impressionado com automação desenvolvida pela StratX. \nDesde a primeira operação, essa ferramenta tem sido um divisor de águas, para mim.Com apenas 50 dias de uso, o retorno bruto chegou aos 48%.",
      author: "Rodrigo Jikal",
      job: "Empresário",
      // "image_url": "https://avatars.githubusercontent.com/u/97165289"
    },
    {
      text: "Tivemos uma temporada de resultados em Outubro/24 e Novembro/24, depois resultados Dezembro/24 a Fevereiro/25 foram levemente negativos, a partir de Março/25, vieram os resultados positivos e hoje estamos com 80% de rendimentos.",
      author: "Francisco",
      job: "Professor Aposentado",
      // "image_url": "https://avatars.githubusercontent.com/u/97165289"
    },
  ],
};
